"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "d-flex flex-gap" };
const _hoisted_2 = { class: "form-radio form-inline" };
const _hoisted_3 = ["checked"];
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* HOISTED */);
const _hoisted_5 = { class: "form-radio form-inline" };
const _hoisted_6 = ["checked", "disabled"];
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-required-divider" }, null, -1 /* HOISTED */);
const _hoisted_9 = {
    key: 0,
    class: "relative"
};
const _hoisted_10 = { class: "form-group d-flex flex-gap flex-align-center flex-justify-between flex-wrap" };
const _hoisted_11 = { class: "d-flex flex-align-center flex-wrap" };
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "必要人数", -1 /* HOISTED */);
const _hoisted_13 = { class: "d-flex" };
const _hoisted_14 = { class: "form-radio form-inline ml-2" };
const _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* HOISTED */);
const _hoisted_16 = { class: "form-radio form-inline" };
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* HOISTED */);
const _hoisted_18 = {
    key: 0,
    class: "d-flex"
};
const _hoisted_19 = /*#__PURE__*/ (0, vue_2.createElementVNode)("button", {
    class: "btn btn-secondary",
    onclick: "showDashModal(true, 'role-csv')"
}, "インポート", -1 /* HOISTED */);
const _hoisted_20 = /*#__PURE__*/ (0, vue_2.createElementVNode)("button", {
    class: "btn btn-secondary",
    onclick: "outputRoleCSV()"
}, "ダウンロード", -1 /* HOISTED */);
const _hoisted_21 = { class: "form-group d-flex flex-gap mt-2 flex-align-center flex-wrap" };
const _hoisted_22 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "配置スタッフ", -1 /* HOISTED */);
const _hoisted_23 = { class: "d-flex flex-wrap ml-2" };
const _hoisted_24 = { class: "form-radio form-inline" };
const _hoisted_25 = ["checked"];
const _hoisted_26 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* HOISTED */);
const _hoisted_27 = { class: "form-radio form-inline" };
const _hoisted_28 = ["checked"];
const _hoisted_29 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* HOISTED */);
const _hoisted_30 = {
    class: "oplus-form-checkbox m-1",
    for: "evenly"
};
const _hoisted_31 = ["checked"];
const _hoisted_32 = {
    class: "oplus-form-checkbox m-1",
    for: "work-evenly"
};
const _hoisted_33 = ["checked"];
const _hoisted_34 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "配置スタッフ", -1 /* HOISTED */);
const roles_1 = require("../../js/roles");
const RoleRequiredCalendar_vue_1 = __importDefault(require("../../roleRequiredCalendar/RoleRequiredCalendar.vue"));
const RoleRequiredByDay_vue_1 = __importDefault(require("./RoleRequiredByDay.vue"));
const RoleRequiredByStaff_vue_1 = __importDefault(require("./RoleRequiredByStaff.vue"));
const RoleRequiredWeekly_vue_1 = __importDefault(require("./RoleRequiredWeekly.vue"));
const vue_3 = require("vue");
// inject RoleView
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredWrapper',
    props: {
        hasAutoPerm: Boolean,
    },
    setup(__props) {
        const role = (0, vue_3.inject)("roleView");
        const roleRequiredType = (0, vue_3.computed)(() => {
            return role?.value.type || 0;
        });
        const roleDaysReqSettings = (0, vue_3.ref)(0);
        const employeePriorityType = (0, vue_3.ref)(role?.value.employeePriority ?? 1);
        const evenly = (0, vue_3.ref)(Boolean(role?.value.evenly));
        const workEvenly = (0, vue_3.ref)(Boolean(role?.value.workEvenly));
        async function handleEmpPriorityChange(value) {
            employeePriorityType.value = value;
            if (!role) {
                return;
            }
            await (0, roles_1.handleRoleEmpPriorityUpdate)(role.value.id, value);
        }
        async function handleEvenlyChange(e) {
            if (!role) {
                return;
            }
            const target = e.target;
            const value = target.checked;
            await (0, roles_1.handleRoleEvenlyUpdate)(role?.value.id, value);
        }
        async function handleWorkEvenlyChange(e) {
            if (!role) {
                return;
            }
            const target = e.target;
            const value = target.checked;
            await (0, roles_1.handleRoleWorkEvenlyUpdate)(role.value.id, value);
        }
        async function handleTypeChange(type) {
            if (!role) {
                return;
            }
            await (0, roles_1.handleRoleTypeUpdate)(role.value.id, type);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createCommentVNode)(" Radio for now, in the future it will be change to checkbox "),
                    (0, vue_2.createElementVNode)("label", _hoisted_2, [
                        (0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            name: "role-type-settings",
                            value: 0,
                            onChange: _cache[0] || (_cache[0] = ($event) => (handleTypeChange(0))),
                            checked: (0, vue_2.unref)(role)?.type === 0
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
                        _hoisted_4,
                        (0, vue_2.createTextVNode)(" 曜日別 ")
                    ]),
                    (0, vue_2.createElementVNode)("label", _hoisted_5, [
                        (0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            name: "role-type-settings",
                            value: 1,
                            onChange: _cache[1] || (_cache[1] = ($event) => (handleTypeChange(1))),
                            checked: (0, vue_2.unref)(role)?.type === 1,
                            disabled: !__props.hasAutoPerm
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
                        _hoisted_7,
                        (0, vue_2.createTextVNode)(" スタッフごと ")
                    ])
                ]),
                _hoisted_8,
                (roleRequiredType.value === 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                _hoisted_12,
                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_14, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "radio",
                                            name: "role-days-settings",
                                            value: 0,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((roleDaysReqSettings).value = $event))
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roleDaysReqSettings.value]
                                        ]),
                                        _hoisted_15,
                                        (0, vue_2.createTextVNode)(" 設定 ")
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_16, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "radio",
                                            name: "role-days-settings",
                                            value: 1,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((roleDaysReqSettings).value = $event))
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roleDaysReqSettings.value]
                                        ]),
                                        _hoisted_17,
                                        (0, vue_2.createTextVNode)(" 上書き ")
                                    ])
                                ])
                            ]),
                            (roleDaysReqSettings.value === 1)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                                    (0, vue_2.createCommentVNode)(" ToDO: refactor these buttons as well "),
                                    _hoisted_19,
                                    _hoisted_20
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ]),
                        (0, vue_2.createCommentVNode)(" Settings type 0 (設定)"),
                        (roleDaysReqSettings.value === 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleRequiredWeekly_vue_1.default, { key: 0 }))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                (0, vue_2.createCommentVNode)(" Settings type 1 (上書き) "),
                                (0, vue_2.createVNode)(RoleRequiredCalendar_vue_1.default)
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                            _hoisted_22,
                            (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                (0, vue_2.createElementVNode)("label", _hoisted_24, [
                                    (0, vue_2.createElementVNode)("input", {
                                        type: "radio",
                                        name: "employee-priority-settings",
                                        checked: employeePriorityType.value === 0,
                                        onChange: _cache[4] || (_cache[4] = ($event) => (handleEmpPriorityChange(0)))
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_25),
                                    _hoisted_26,
                                    (0, vue_2.createTextVNode)(" 上優先 ")
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_27, [
                                    (0, vue_2.createElementVNode)("input", {
                                        type: "radio",
                                        name: "employee-priority-settings",
                                        checked: employeePriorityType.value === 1,
                                        onChange: _cache[5] || (_cache[5] = ($event) => (handleEmpPriorityChange(1)))
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_28),
                                    _hoisted_29,
                                    (0, vue_2.createTextVNode)(" ランダム ")
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_30, [
                                    (0, vue_2.createTextVNode)(" 均等に "),
                                    (0, vue_2.createElementVNode)("input", {
                                        id: "evenly",
                                        onChange: handleEvenlyChange,
                                        checked: evenly.value,
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_31)
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_32, [
                                    (0, vue_2.createTextVNode)(" 出勤数順 "),
                                    (0, vue_2.createElementVNode)("input", {
                                        id: "work-evenly",
                                        onChange: handleWorkEvenlyChange,
                                        checked: workEvenly.value,
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_33)
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" Staff list "),
                        (0, vue_2.createVNode)(RoleRequiredByDay_vue_1.default)
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                        (0, vue_2.createCommentVNode)(" Role Type 1 "),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createCommentVNode)(" Staff list "),
                            (0, vue_2.createElementVNode)("div", null, [
                                _hoisted_34,
                                (0, vue_2.createVNode)(RoleRequiredByStaff_vue_1.default)
                            ])
                        ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
